import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable, of, empty } from 'rxjs';
import { ListingsService } from '../services/listings.service';
import { map, catchError } from 'rxjs/operators';
import {CommunicationService} from '../services/communication.service';
import {ListingCategory} from '../classes/enums';
import {Commercial, Luxury, Provinces} from '../app-config.constants';
import { PreRenderService } from '../services/pre-render.service';
import { UrlSanitizerService } from '../services/url-sanitizer.service';
import { UrlValidator } from './url-validator';

@Injectable()
export class MapCityResolver extends UrlValidator implements Resolve<any> {

  constructor(
    private _listingsService: ListingsService,
    private _communicationService: CommunicationService,
    protected _preRenderService: PreRenderService,
    protected _urlSanitizerService: UrlSanitizerService,
    protected _router: Router
  ) {
    super(_urlSanitizerService, _router, _preRenderService);
   }

  resolve(route: ActivatedRouteSnapshot, rstate: RouterStateSnapshot): Observable<any> {
    const url = rstate.root.firstChild.url;
    const cityRegex =  /(.+)-real-estate/;


    const province = url.length === 3 ? url[1].path : url[0].path;
    let category = '/';

    if (!this._preRenderService.isServerMode) {
      const referrer = document.referrer.split('/');
      category = referrer[referrer.length - 1]
    }

    const listingCategory =  url.length === 3 ? this.getListingCategory(url[0].path) :  this.getListingCategory(category);
    this._communicationService.setCurrentListingType(listingCategory);
    const cityMatches = cityRegex.exec(url.length === 3 ? url[2].path : url[1].path);

    let pageNumber = Number(route.queryParams.page) || 0; // For Pagination
    // We need to remember to decrement this value as pagination arrays start from 0
    if (pageNumber > 0) pageNumber--;

    if (cityMatches && cityMatches.length === 2) {

      let cityName = cityMatches[1];

      // Reformat city name for front end after parsing from URL
      // Capitalize after space, hyphen, slash and replace hyphen with space
      cityName = cityName.replace(/(^\w{1})|([\s-/]{1}\w{1})/g, match => match.toUpperCase());
      cityName = cityName.replace(/-/g, ' ');

      const cityNameArr = cityName.split(/[-,.']+/);

      if (!this.isValidUrl(url, route.queryParams)) return empty();

      if (cityNameArr.length > 1 && cityNameArr.indexOf('') !== -1 ) {
        const fallbackUrl = `${url[0]}/${cityNameArr[0]}-real-estate`;
        this._router.navigate([`/${fallbackUrl}`], { queryParams: route.queryParams });
        this._preRenderService.setPreRenderFlag(301, fallbackUrl, route.queryParams);
        return empty();
      } else if (cityNameArr.length > 1 && cityNameArr.indexOf('') === -1) {
          let found = false;
          for (let i = 0; i < cityNameArr.length ; i++) {
            if (Provinces.findIndex(g => (g.short.toLowerCase() === cityNameArr[i].toLowerCase() || g.medium.toLowerCase() === cityNameArr[i].toLowerCase() || g.long.toLowerCase() === cityNameArr[i].toLowerCase())) !== -1) {
              found = true;
            }
          }

          if (found) {
            const fallbackUrl = `${url[0]}/${cityNameArr[0]}-real-estate`;
            this._router.navigate([`/${fallbackUrl}`], { queryParams: route.queryParams });
            this._preRenderService.setPreRenderFlag(301, fallbackUrl, route.queryParams);
          }
      }

      // Make a call to the listings to find the total hits before returning
      return this._listingsService.getListingsCount(false, province, cityName).pipe(
        map((hits) => {
          return {city: cityName, province: province, totalListings: hits, pageNumber: pageNumber, category: listingCategory};
        }),
        // FIXME: What should i do here
        catchError((err) => {
          return of({city: cityName, province: province, totalListings: 0, pageNumber: pageNumber,  category: listingCategory});
        }));
    }
    else return of(null);
  }

  private getListingCategory(listingCategory: string) {
    switch (listingCategory) {
      case Luxury:
        return ListingCategory.LUXURY;
      case Commercial:
        return ListingCategory.COMMERCIAL;
      default:
        return this._communicationService.listings.currentShownListingType.getValue();
    }
  }
}
